import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { addressApi } from '../../lib/addressApi';
import DeliveryAddresses from './DeliveryAddresses';
import './Account.css';
export default function ProfilePage() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();
  // RequireAuth guarantees a signed-in user; this only narrows the type.
  if (!user) return null;
  return (
    <section className="account-page page-container">
      <h1>Your profile</h1>
      <dl className="profile-details">
        <div className="profile-details__row">
          <dt>Name</dt>
          <dd>{user.first_name}</dd>
        </div>
        <div className="profile-details__row">
          <dt>Email</dt>
          <dd>
            {user.email} · {user.email_verified ? 'Verified' : 'Not verified'}
          </dd>
        </div>
        <div className="profile-details__row">
          <dt>Phone</dt>
          <dd>
            {user.phone_number} · {user.phone_number_verified ? 'Verified' : 'Not verified'}
          </dd>
        </div>
      </dl>
      <nav>
        <Link to="/orders">Your orders</Link> · <Link to="/wishlist">Wishlist</Link> ·{' '}
        <Link to="/rewards">Rewards and referrals</Link>
      </nav>
      <h2>Delivery addresses</h2>
      <DeliveryAddresses key={user.id} api={addressApi} />
      <button onClick={() => void logout().then(() => navigate('/login', { replace: true }))}>Log out</button>
    </section>
  );
}
